import {
  IAnalyticsDataLayerService, IControlCenterEventParams
} from "./analytics-data-layer.service.interface";
import {ServiceBase} from "../ServiceBase";


export class AnalyticsDataLayerService extends ServiceBase implements IAnalyticsDataLayerService{

  public pushControlCenterEvent(eventParams: IControlCenterEventParams): void {
      this._push(eventParams);
      this.services.sdk.structuredLoggingService.getLogger()
          .addCategory("SAFEZONE TRACKING")
          .addAction(eventParams.action)
          .addLabel(eventParams.correlation_id)
          .addValue(JSON.stringify(eventParams))
          .info();
  }

  private _push(params: {}):void{
    if(params){
      this.services.sdk.pushDataToDataLayer(params);
    }
  }
}
